import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { CreateRedPocketEnvelopeRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { CreateRedPocketEnvelopeResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const createRedPocketEnvelope = (request: CreateRedPocketEnvelopeRequest, options?: CashRequestOptions) =>
  post<CreateRedPocketEnvelopeRequest, CreateRedPocketEnvelopeResponse>(
    '/2.0/cash/create-red-pocket-envelope',
    request,
    { ...options, rejectOnError: true }
  )
